import { getCookieAuthOverride, setCookieAuthEnabled } from "/@lib/cookie-auth"
import session from "/@lib/tastyworks-rest/session"
import { TastyLDClient } from "@tastyworks/launch-darkly"
import { get } from "svelte/store"
import { FLAGS } from "./flags"

const APP_NAME = "tradedesk"

let ready: Promise<void> | undefined

function buildContext(): Record<string, unknown> {
  const username = session.currentUsername
  if (!username) {
    return { kind: "user", anonymous: true, app: APP_NAME }
  }

  return {
    kind: "user",
    key: username,
    email: session.currentEmail,
    username,
    app: APP_NAME,
  }
}

async function connect(): Promise<void> {
  const client = new TastyLDClient(
    import.meta.env.VITE_LAUNCHDARKLY_SDK_CLIENT,
    buildContext(),
    FLAGS
  )
  await client.initialize()
  setCookieAuthEnabled(
    getCookieAuthOverride() ?? get(client.flags.cookieAuthEnabled)
  )
}

export function initLaunchDarkly(): Promise<void> {
  if (!ready) {
    ready = connect().catch((error) => {
      console.error("LaunchDarkly initialization failed", error)
      setCookieAuthEnabled(getCookieAuthOverride() ?? false)
    })
  }

  return ready
}
